import auth from '@/router/middlewares/auth';

export default [
  // {
  //   path: '/albums',
  //   alias: ['/workspace/:workspaceID?/:workspaceName?/albums'],
  //   component: () => import('@/pages/album/index.vue'),
  //   name: 'Albums',
  //   meta: {
  //     layout: 'AuthenticatedLayout',
  //     middleware: [auth]
  //   }
  // },
  // {
  //   path: '/album/:albumID',
  //   component: () => import('@/pages/album/album.vue'),
  //   name: 'Album',
  //   meta: {
  //     layout: 'AuthenticatedLayout',
  //     middleware: [auth]
  //   }
  // }
];


